// extracted by mini-css-extract-plugin
export default {"container":"dropdown_container__HwMaP","boxShadow":"dropdown_boxShadow__TODYv","dropdown":"dropdown_dropdown__jtQOo","item":"dropdown_item__F+ny4","icon":"dropdown_icon__DlMFS"};